<template>
  <vv-progress-bar
    :progression="lessonStepProgression.currentLesson"
    :total="lessonStepProgression.numberOfLessons"
  />
</template>

<script>
import { VvProgressBar } from '@/components/common'
import { mapGetters } from 'vuex'

export default {
  name: 'LessonProgressBar',
  components: { VvProgressBar },
  computed: {
    ...mapGetters({ lessonStepProgression: 'lessonStepProgression' })
  }
}
</script>
